import { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, IconButton } from "@mui/material";
import { downloadTemporaryFileRequest } from "../../../../utils/APICalls";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

export default function DragPhoto({ photoData }: any) {
  const [photoUrl, setPhotoUrl] = useState("");

  const prevKeyRef = useRef(null);

  useEffect(() => {
    if (photoData) {
      if (photoData.key !== prevKeyRef.current) {
        prevKeyRef.current = photoData.key;
        getPhotoUrl(photoData.key);
      }
    }
  }, [photoData]);

  const getPhotoUrl = async (key: string) => {
    const response = await downloadTemporaryFileRequest(key);
    if (response && response.data) {
      setPhotoUrl(response.data);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          border: "1px solid #C4C4C4",
          p: 2,
          display: "flex",
          mt: 1,
          opacity: 0.6,
        }}
      >
        <Box
          sx={{
            width: 300,
            height: 200,
            position: "relative",
          }}
        >
          {!photoUrl ? (
            <CircularProgress
              size={24}
              sx={{ position: "absolute", top: "45%", left: "45%" }}
            />
          ) : (
            <Box
              component="img"
              src={photoUrl}
              alt="Photo"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </Box>
        <Box sx={{ width: "100%", mx: 4, my: 2, color: "grey" }}>
          {photoData.description}
        </Box>
        <IconButton sx={{ height: 40 }} aria-label="delete">
          <DeleteOutlinedIcon color={"error"} />
        </IconButton>
        <IconButton sx={{ height: 40 }} aria-label="drag">
          <DragIndicatorIcon color={"primary"} />
        </IconButton>
      </Box>
    </Box>
  );
}
